import MaskedInput from 'react-text-mask'
import React, {
  ChangeEventHandler,
  FocusEventHandler,
  FC,
  useCallback,
} from 'react'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

interface Props {
  name: string
  value: string
  title?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
}

const PercentInput: FC<Props> = ({
  name,
  value,
  onChange,
  onBlur = (e) => {},
  title,
  ...rest
}) => {
  const [localPercentValue, setLocalPercentValue] = React.useState<
    string | undefined
  >(String(Number(value) * 100))

  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      const stripPercent = e.target.value.replace(/% ?/g, '')
      // convert  to a float for math and convert back
      const newValue = (Number(stripPercent) / 100).toString()
      const newEvent: React.ChangeEvent<HTMLInputElement> = {
        ...e,
        target: {
          ...e.target,
          name,
          value: newValue,
        },
      }
      onChange(newEvent)
      // accounts for suffix
      setLocalPercentValue(e.target.value)
    },
    [name, onChange]
  )

  return (
    <MaskedInput
      mask={percentMask}
      value={localPercentValue}
      autoComplete={'off'}
      guide={false}
      name={name}
      pipe={updateMask}
      className="input__field --percent"
      onChange={handleChange}
      onBlur={onBlur}
      maxLength="4"
      title={title}
      {...rest}
    />
  )
}

export default PercentInput

const updateMask = (val) => {
  if (val.slice(-1) === '%') return val
  const value = `${val}%`
  return {
    value,
    indexesOfPipedChars: [value.slice(-1)],
  }
}

const percentMask = createNumberMask({ suffix: '%', prefix: '' })
